module.exports = "/_next/static/images/9726a0c4ad075cb243afd01fd6850b4c-Nubank_HickDuarte_58654 (2) 1_xs.jpg.webp";